<script lang="ts">
  import { HOW_IT_WORKS_STEPS } from '../../utils/constants'
</script>

<section class="py-24">
  <div class="container mx-auto px-4 md:px-16 xl:px-24">
    <div class="text-center mb-16">
      <h2 class="text-4xl md:text-5xl font-bold mb-6">How It Works</h2>
      <p class="text-am-black-75 max-w-xl mx-auto">
        Qualify meetings automatically in three simple steps with no scheduling chaos or manual back and forth.
      </p>
    </div>

    <div class="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
      {#each HOW_IT_WORKS_STEPS as step, i}
        <div
          class="p-5 md:p-8 bg-am-blue-15 rounded-2xl flex flex-col gap-8 md:gap-16 !justify-between bg-gray-100 md:min-h-[340px] hover:bg-gray-200 transition duration-300 ease-in-out"
        >
          <h3 class="text-am-black text-2xl">({step.number})  {step.title}</h3>
          <p class="text-am-black-75 md:flex-1 max-w-sm !font-semibold !mt-auto ">
            {step.content}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>
